import axios from 'axios';

// 환경변수가 없을 경우 8081 포트로 fallback
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081';

console.log('API URL:', API_URL);

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// [1] 요청 인터셉터: 매 요청마다 토큰 자동 삽입
instance.interceptors.request.use(
    (config) => {
        // ※ 로그인 시 localStorage에 저장한 키 이름과 일치해야 합니다 (기본값: 'token')
        const token = localStorage.getItem('token'); 
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            console.warn("현재 localStorage에 token이 없습니다.");
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// [2] 응답 인터셉터: 세션 만료 및 권한 에러 처리
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            const status = error.response.status;
            const config = error.config;

            // 백엔드가 전달한 에러 메시지 추출
            const serverMessage = error.response.data?.message 
                || (typeof error.response.data === 'string' ? error.response.data : null);

            // 로그인과 회원가입 요청일 때만 예외 처리 대상에서 제외 (경로를 명확히 지정)
            const isMemberAuthRequest = config.url.includes('/api/member/login') || config.url.includes('/api/member/signup');

            if ((status === 401 || status === 403) && !isMemberAuthRequest) {
                console.warn("세션이 만료되었거나 권한이 없어 로그아웃 처리합니다.");
                
                const alertMsg = serverMessage || '세션이 만료되었거나 접근 권한이 없습니다. 다시 로그인해 주세요.';
                alert(alertMsg);

                localStorage.removeItem('token');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default instance;